import { useState } from "react";
import * as global from "@components";

/**
 * MapTemplate Component, is used for: [JMRV, LUCA, REDDAI]
 *
 * This component displays a web page section that shows:
 * - A header with meta information (like page title and description)
 * - A map embedded inside an iframe (like a window showing another website)
 *
 * While the map is loading, it shows a loading indicator (provided in the constants).
 *
 * Props:
 * - constants: An object containing configuration such as:
 *    - metaProps: Information for the page header (title, description, etc.)
 *    - loading: What to display while the map is loading (e.g. a spinner)
 *    - url: The web address of the map to display inside the iframe
 */
export default function MapTemplate({ constants }) {
    // loading state keeps track if the map iframe is still loading
    const [loading, setLoading] = useState(true);

    return (
        <>
            {/* HEADER */}
            {/* This renders the page metadata like title and description */}
            <global.MetaTagHeader {...constants.metaProps} />

            {/* MAIN MAP CONTAINER */}
            <div className="h-[100dvh] w-full md:mt-[60px] md:h-iframeScreen">
                {/* Show the loading indicator while the iframe content loads */}
                {loading && constants.loading}

                {/* 
                    iframe embeds another webpage (the map).
                    When it finishes loading, we update the loading state to hide the loading indicator.
                */}
                <iframe
                    title="map"
                    src={constants.url} // The URL of the map to embed
                    className={loading ? "" : "h-full w-full"} // Make iframe fill container after loading
                    onLoad={() => setLoading(false)} // Called when iframe finishes loading
                    allow="clipboard-write" // Allows clipboard access inside iframe
                />
            </div>
        </>
    );
}
